/**
 * Wraps Superagent
 * @param  {Object} superagent
 * @param  {String} type
 * @return {void}
 */
function logError(handler) {
    return function(request) {
        var end = request.end;
        request.end = function(cb) {
            return end.call(this, (err, res) => {
                if (res && res.error) {
                    if (res.error.message) {
                        console.log(res.error.message);
                        console.log(err);
                    } else {
                        console.log(err);
                    }
                }

                if (typeof cb !== 'function') return;
                cb(err, res);
            });
        };
        return request;
    };
}

module.exports = logError;



// WEBPACK FOOTER //
// ./src/shared/superagent-logerror.js